var CssClasses;
(function(CssClasses) {
CssClasses['MENU_OPEN'] = 'glue-header__menu--open';
})(CssClasses || (CssClasses = {}));
var Strings;
(function(Strings) {
Strings['NO_CHILDREN'] =
    'PopupMenu constructor argument el has no element children.';
})(Strings || (Strings = {}));
export {CssClasses, Strings};
